"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
var _methods = require("@/components/Store/SalesKPIRecord/methods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'salesPerformanceCity',
      searchQuery: {
        type: '1',
        month: curDateTree.month,
        srEmpName: ''
      },
      apiModule: 'kpiSet',
      urlModule: 'REPORT'
    };
  },
  computed: {
    domData: function domData() {
      return {
        month: {
          label: this.$t("sfe.salesPerformance.month"),
          valueKey: "month",
          inputType: "date",
          type: "month",
          valueFormat: "yyyyMM"
        },
        pcd: {
          label: this.$t("sfe.salesPerformance.pcd"),
          inputType: "pcd",
          regionProps: {
            expandTrigger: "hover",
            checkStrictly: true
          },
          keyList: ["region", "regionCode", "city", "cityCode", "district", "districtCode"]
        },
        srEmpName: {
          label: this.$t("sfe.salesPerformance.srEmpName"),
          valueKey: "srEmpName"
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t("sfe.route.salesperformancecity"),
          apiUrl: "/protected/pc/report/city/salePerformance/export/new"
        }
      };
    },
    tableDom: function tableDom() {
      return {
        region: {
          label: this.$t('sfe.salesPerformance.region')
        },
        city: {
          label: this.$t('sfe.salesPerformance.city')
        },
        district: {
          label: this.$t('sfe.salesPerformance.district')
        },
        storeCode: {
          label: this.$t('sfe.salesPerformance.storeCode')
        },
        storeName: {
          label: this.$t('sfe.salesPerformance.storeName'),
          minWidth: 240
        },
        empName: {
          label: this.$t('sfe.salesPerformance.empName')
        },
        retailerType: {
          label: this.$t('sfe.salesPerformance.retailerType')
        },
        storeType: {
          label: this.$t('sfe.salesPerformance.storeType')
        },
        tppQty: {
          label: this.$t('sfe.salesPerformance.tppQty')
        },
        saleQty: {
          label: this.$t('sfe.salesPerformance.saleQty')
        },
        actualEighteenQty: {
          label: this.$t('sfe.salesPerformance.actualEighteenQty')
        },
        luxQty: {
          label: this.$t('sfe.salesPerformance.luxQty')
        },
        suvQty: {
          label: this.$t('sfe.salesPerformance.suvQty')
        },
        evQty: {
          label: this.$t('sfe.salesPerformance.evQty')
        },
        // atcQty: {
        //   label: this.$t('sfe.salesPerformance.atcQty')
        // },
        // amgQty: {
        //   label: this.$t('sfe.salesPerformance.amgQty')
        // },
        // a6Qty: {
        //   label: this.$t('sfe.salesPerformance.a6Qty')
        // },
        newProduct1Qty: {
          label: this.$t('sfe.salesPerformance.newProduct1Qty')
        },
        newProduct2Qty: {
          label: this.$t('sfe.salesPerformance.newProduct2Qty')
        },
        newProduct3Qty: {
          label: this.$t('sfe.salesPerformance.newProduct3Qty')
        },
        newProduct4Qty: {
          label: this.$t('sfe.salesPerformance.newProduct4Qty')
        },
        warrantyQty: {
          label: this.$t('sfe.salesPerformance.warrantyQty')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/app/store/report/city/performance/new'
      };
    }
  },
  methods: {}
};